export default __webpack_public_path__ + "static/media/progress.20ca1994.png";